import { HttpErrorResponse } from '@angular/common/http';
import { SettlementActionRejectedApiError } from '../services/settlement-action-api.types';

const REJECTION_STATUSES = [409, 422];

// 409/422 son rechazos de negocio con mensaje listo para mostrar; el resto se trata como error técnico.
export const rejectionMessage = (cause: unknown, fallback: string): string | null => {
  if (!(cause instanceof HttpErrorResponse) || !REJECTION_STATUSES.includes(cause.status)) {
    return null;
  }
  return (
    (cause.error as Partial<SettlementActionRejectedApiError> | null)?.error?.message ?? fallback
  );
};
